import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "stored_value_manager"
};
const _hoisted_2 = {
  class: "base_screen_header"
};
const _hoisted_3 = {
  key: 0,
  class: "btn-box"
};
const _hoisted_4 = {
  key: 1,
  class: "btn-box"
};
const _hoisted_5 = {
  class: "base_main_margin_top"
};
const _hoisted_6 = {
  class: "base_main_header"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "旅游合同", -1);

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "其他合同", -1);

const _hoisted_9 = {
  key: 0,
  class: "base_main_margin_top"
};
const _hoisted_10 = {
  key: 1,
  class: "base_main_margin_top"
};
const _hoisted_11 = {
  class: "container1"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode(" 将合同.pdf、doc、docx 文件拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1);

const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, [/*#__PURE__*/_createElementVNode("div", null, "注意："), /*#__PURE__*/_createElementVNode("div", null, "1.pdf、doc、docx文件上传完成后点击下方保存")], -1);

const _hoisted_14 = {
  class: "dialog-footer"
};
import StatusBar from "@com/StatusBar.vue";
import { $msg, $box } from "@ui/msg";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { OP_KEY, COLUMN_TYPE, OPERATIONS, operationsHander } from "@com/table/tableOperations";
import $ from "@util/base";
import api from "@api/contract";
import { UPLOAD_URL } from "@net/url";
import auth from "@/common/net/auth";
import LockFileView from "@com/LockFileView.vue";
const name = 'file_data';
export default {
  __name: 'ContractManager',

  setup(__props) {
    const url = UPLOAD_URL;
    const headers = {
      accessToken: auth.getToken()
    };
    const route = useRoute();
    const file = ref(null);
    const upload = ref(null);
    route.watchRouter("contractmanager", () => {
      getData();
    });

    function uploadSuccess(response) {
      if (response.code === 0) {
        file.value = response.data.fileUrl;
      }
    }

    const typeOptions = ref([]);
    const statusList = reactive([{
      label: "全部",
      value: "1",
      total: 0
    }, {
      label: "失效",
      value: "1068003",
      total: 0
    }, {
      label: "生效中",
      value: "1068002",
      total: 0
    }]);
    const data = ref([]);
    const total = ref(0);

    function getOperations(data) {
      return [OPERATIONS.modify, OPERATIONS.del];
    }

    function getOperations2(data) {
      if ($.isNotEmpty(data.annex)) {
        return [OPERATIONS.check, OPERATIONS.down]; // return [ OPERATIONS.down];
      } else {
        return [OPERATIONS.up];
      }
    }

    const configTravel = {
      showIndex: true,
      operations: {
        label: "操作",
        operations: getOperations
      },
      column: [{
        label: "合同编号",
        prop: "contractCode"
      }, {
        label: "产品名称",
        prop: "travelName"
      }, {
        label: "签订日期",
        prop: "signDate"
      }, {
        label: "游客（客户）",
        prop: "guest"
      }, {
        label: "联系电话",
        prop: "phone"
      }],
      operations2: {
        label: "附件合同",
        width: 120,
        operations: getOperations2
      }
    };
    const config = {
      showIndex: true,
      operations: {
        label: "操作",
        width: 120,
        operations: getOperations
      },
      column: [{
        label: "合同类型",
        prop: "contractTypeName"
      }, {
        label: "合同名称",
        prop: "contractName",
        width: 120
      }, {
        label: "签订单位甲",
        prop: "signCompany1"
      }, {
        label: "签订单位乙",
        prop: "signCompany2"
      }, {
        label: "签订单位丙",
        prop: "signCompany3"
      }, {
        label: "签订单位丁",
        prop: "signCompany4"
      }, {
        label: "签订日期",
        prop: "signDate",
        width: 160
      }, {
        label: "合同起始日期",
        prop: "startDate",
        width: 160
      }, {
        label: "合同终止日期",
        prop: "endDate",
        width: 160
      }, {
        label: "上传建档日期",
        prop: "createDate",
        width: 160
      }, {
        label: "合同金额",
        prop: "contractMoney",
        width: 180
      }, {
        label: "合同签订部门",
        prop: "signDepartment"
      }, {
        label: "合同负责人",
        prop: "head",
        width: 120
      }, {
        label: "合同编码",
        prop: "contractCode"
      }, {
        label: "项目名称",
        prop: "projectName",
        width: 160
      }, {
        label: "合同份数",
        prop: "contractNum",
        width: 100
      }, {
        label: "款项支付周期",
        prop: "payCycle",
        width: 180
      }, {
        label: "合同状态",
        prop: "contractStatusName",
        width: 160,
        type: COLUMN_TYPE.linkText,
        operationsKey: OPERATIONS.linkText
      }, {
        label: "备注",
        prop: "remark"
      }],
      operations2: {
        label: "附件合同",
        width: 120,
        operations: getOperations2
      }
    };
    var readOnly = false;
    const dialogVisible = ref(false);
    const getDialogVisible = ref(false);
    const getUrl = ref();
    const ikey = new Date().getTime(); // 使用时间戳

    const formRef = ref(null);
    const Iframe = ref();
    const loading = ref(false);
    const form = reactive({
      id: null,
      contractType: null,
      contractName: null,
      signCompany1: null,
      signCompany2: null,
      signCompany3: null,
      signCompany4: null,
      signDate: null,
      startDate: null,
      endDate: null,
      createDate: null,
      contractMoney: null,
      signDepartment: null,
      head: null,
      contractCode: null,
      projectName: null,
      contractNum: 0,
      payCycle: null,
      remark: null,
      annex: null
    });

    function close() {
      form.id = null, form.contractType = null, form.contractName = null, form.signCompany1 = null, form.signCompany2 = null, form.signCompany3 = null, form.signCompany4 = null, form.signDate = null, form.startDate = null, form.endDate = null, form.createDate = null, form.contractMoney = null, form.signDepartment = null, form.head = null, form.contractCode = null, form.projectName = null, form.contractNum = 0, form.payCycle = null, form.remark = null, form.annex = null, dialogVisible.value = false;
    }

    function add() {
      form.id = null, form.contractType = null, form.contractName = null, form.signCompany1 = null, form.signCompany2 = null, form.signCompany3 = null, form.signCompany4 = null, form.signDate = null, form.startDate = null, form.endDate = null, form.createDate = null, form.contractMoney = null, form.signDepartment = null, form.head = null, form.contractCode = null, form.projectName = null, form.contractNum = 0, form.payCycle = null, form.remark = null, form.annex = null, dialogVisible.value = true;
    }

    function openImport() {
      route.push({
        name: "contractimport"
      });
    }

    const rules = {
      contractCode: [{
        required: true,
        message: "请输入合同编号",
        trigger: "blur"
      }]
    };

    const submitForm = formEl => {
      if (!formEl) return;
      formEl.validate((valid, fields) => {
        if (valid) {
          const data = {};
          Object.assign(data, form);
          data.annex = file.value;

          if (data.id) {
            // 有id为编辑
            api.update(data, () => {
              $msg.succ("修改成功");
              dialogVisible.value = false;
              getData();
            });
          } else {
            userStoredValue(form);
          }
        }
      });
    };

    function userStoredValue(data) {
      data.annex = file.value;
      api.add(data, () => {
        $msg.succ("新增成功");
        dialogVisible.value = false;
        getData();
      });
    }

    const resetForm = formEl => {
      if (!formEl) return;
      formEl.resetFields();
    };

    const opHander = operationsHander();
    opHander.install(OP_KEY.check, data => {
      // appletsCodeRef.value.show({url: data.annex});
      if ($.isNotEmpty(data.annex)) {
        let row = data.annex;
        let index = row.lastIndexOf(".");
        let ext = row.substr(index); // getUrl.value = 'https://view.xdocin.com/view?src=' + row;

        api.lock({
          id: data.id
        }, val => {
          console.log("val" + JSON.stringify(val));
          getUrl.value = val.url;
          getDialogVisible.value = true;
        });
      }
    });
    opHander.install(OP_KEY.down, data => {
      let url = "";
      api.lock({
        id: data.id
      }, val => {
        console.log("val" + JSON.stringify(val));
        $.download(val.url, data.contractCode + "附件下载");
      });
    });
    opHander.install(OP_KEY.up, data => {
      form.id = data.id, form.contractType = data.contractType, form.contractName = data.contractName, form.signCompany1 = data.signCompany1, form.signCompany2 = data.signCompany2, form.signCompany3 = data.signCompany3, form.signCompany4 = data.signCompany4, form.signDate = data.signDate, form.startDate = data.startDate, form.endDate = data.endDate, form.createDate = data.createDate, form.contractMoney = data.contractMoney, form.signDepartment = data.signDepartment, form.head = data.head, form.contractCode = data.contractCode, form.projectName = data.projectName, form.contractNum = data.contractNum, form.payCycle = data.payCycle, form.remark = data.remark, form.annex = data.annex, readOnly = true;
      dialogVisible.value = true;
    });
    opHander.install(OP_KEY.modify, data => {
      form.id = data.id, form.contractName = data.contractName, form.signCompany1 = data.signCompany1, form.signCompany2 = data.signCompany2, form.signCompany3 = data.signCompany3, form.signCompany4 = data.signCompany4, form.signDate = data.signDate, form.startDate = data.startDate, form.endDate = data.endDate, form.createDate = data.createDate, form.contractMoney = data.contractMoney, form.signDepartment = data.signDepartment, form.head = data.head, form.contractCode = data.contractCode, form.projectName = data.projectName, form.contractNum = data.contractNum, form.payCycle = data.payCycle, form.remark = data.remark, form.annex = data.annex, dialogVisible.value = true;
    });
    opHander.install(OP_KEY.delete, data => {
      $box.open("删除", "确认删除" + data.contractName, () => {
        api.updateWay({
          flag: 0,
          contractCode: data.contractCode
        }, () => {
          $msg.succ("删除成功");
          getData();
        });
      });
    });
    opHander.install(OP_KEY.linkText, data => {
      let statusName = "";
      let status = "";

      if (data.contractStatus == "1068002") {
        statusName = "失效";
        status = "1068003";
      } else {
        statusName = "生效";
        status = "1068002";
      }

      $box.open("合同状态变更", `是否将合同状态改为` + statusName, () => {
        api.updateWay({
          contractStatus: status,
          contractCode: data.contractCode
        }, () => {
          $msg.succ("修改成功");
          getData();
        });
      });
    });
    const type = ref(route.query().type || "travel");
    const orderCode = ref(route.query().orderCode || "");
    const contractInfo = ref(route.query().contractInfo || "");
    const date = ref(route.query().date || []);

    function tabChange(val) {
      route.replaceQuery("type", val);
    }

    function searchOrderCode(val) {
      route.replaceQuery("orderCode", val);
    }

    function searchContractInfo(val) {
      route.replaceQuery("contractInfo", val);
    }

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    getData();

    function getData() {
      getList();
      getStatusNum();
      getConfig();
    }

    function getConfig() {
      api.typeList("", val => {
        console.log("val" + JSON.stringify(val));
        typeOptions.value = val;
      });
    }

    function getList() {
      let routeQuery = route.query();
      let typev = "1";

      if ($.isNotEmpty(routeQuery.type)) {
        typev = routeQuery.type === "travel" ? "1" : "2";
      }

      api.list({
        type: typev,
        contractInfo: routeQuery.contractInfo,
        orderCode: routeQuery.orderCode,
        date: routeQuery.date,
        status: routeQuery.status,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          if (e.changeMoney > 0) {
            e.changeMoney = `+${e.changeMoney}`;
          }

          return e;
        });
      });
    }

    function exportData() {
      let routeQuery = route.query();
      let typev = "1";

      if ($.isNotEmpty(routeQuery.type)) {
        typev = routeQuery.type === "travel" ? "1" : "2";
      }

      api.exportData({
        type: typev,
        // contractInfo: routeQuery.contractInfo,
        orderCode: routeQuery.orderCode,
        date: routeQuery.date,
        status: routeQuery.status,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        $.download(val.url, "合同列表导出");
      });
    }

    function getStatusNum() {
      let routeQuery = route.query();
      let typev = "1";

      if ($.isNotEmpty(routeQuery.type)) {
        typev = routeQuery.type === "travel" ? "1" : "2";
      }

      api.statusNum({
        type: typev,
        contractInfo: routeQuery.contractInfo,
        orderCode: routeQuery.orderCode,
        date: routeQuery.date,
        status: routeQuery.status
      }, val => {
        statusList.forEach((e, i) => {
          e.total = val[i];
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_badge = _resolveComponent("el-badge");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_upload_filled = _resolveComponent("upload-filled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_main = _resolveComponent("el-main");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [type.value === 'other' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_createTextVNode("新增")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('ADD')]]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: openImport
        }, {
          default: _withCtx(() => [_createTextVNode("批量导入合同")]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: date.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => date.value = $event),
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              "value-format": "YYYY-MM-DD",
              onChange: searchDate
            }, null, 8, ["modelValue"])]),
            _: 1
          }), type.value === 'travel' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: orderCode.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderCode.value = $event),
              "onKeyup[native]": searchOrderCode,
              onChange: searchOrderCode,
              placeholder: "订单号",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_createVNode(StatusBar, {
          data: statusList,
          default: 1
        }, null, 8, ["data"])]), _createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          text: "",
          onClick: exportData
        }, {
          default: _withCtx(() => [_createTextVNode("导出")]),
          _: 1
        })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])]), _createVNode(_component_el_tabs, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => type.value = $event),
          class: "stored_order_tabs",
          onTabChange: tabChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            name: "travel"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_badge, null, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            name: "other"
          }, {
            label: _withCtx(() => [_createVNode(_component_el_badge, null, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), type.value === 'travel' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(DataCollectTable, {
          data: data.value,
          config: configTravel,
          total: total.value,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(DataCollectTable, {
          data: data.value,
          config: config,
          total: total.value,
          onOperationsHander: _unref(opHander).receive
        }, null, 8, ["data", "total", "onOperationsHander"])])), _createVNode(_component_el_dialog, {
          modelValue: getDialogVisible.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => getDialogVisible.value = $event),
          top: "1vh",
          title: "查看附件",
          width: "99%",
          height: "99%"
        }, {
          footer: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = $event => getDialogVisible.value = false)
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(LockFileView, {
            title: getUrl.value
          }, null, 8, ["title"])])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: dialogVisible.value,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => dialogVisible.value = $event),
          title: "合同上传",
          width: "60%",
          top: "20vh",
          class: "base_dialog"
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_14, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[24] || (_cache[24] = $event => submitForm(formRef.value))
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: _cache[25] || (_cache[25] = $event => close())
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form,
            rules: rules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同类型",
                    prop: "contractType"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      modelValue: form.contractType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.contractType = $event),
                      placeholder: "请选择合同类型",
                      disabled: _unref(readOnly)
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (item, index) => {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 128))]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同名称",
                    prop: "contractName"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.contractName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.contractName = $event),
                      placeholder: "请输入合同名称",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "签订单位甲",
                    prop: "signCompany1"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.signCompany1,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.signCompany1 = $event),
                      placeholder: "请输入",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "签订单位乙",
                    prop: "signCompany2"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.signCompany2,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.signCompany2 = $event),
                      placeholder: "请输入",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "签订单位丙",
                    prop: "signCompany3"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.signCompany3,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.signCompany3 = $event),
                      placeholder: "请输入",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "签订单位丁",
                    prop: "signCompany4"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.signCompany4,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.signCompany4 = $event),
                      placeholder: "请输入",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "签订日期"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                      modelValue: form.signDate,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.signDate = $event),
                      type: "date",
                      placeholder: "",
                      "value-format": "YYYY-MM-DD",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同起始日期"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                      modelValue: form.startDate,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.startDate = $event),
                      type: "date",
                      placeholder: "",
                      "value-format": "YYYY-MM-DD",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同终止日期"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                      modelValue: form.endtDate,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.endtDate = $event),
                      type: "date",
                      placeholder: "",
                      "value-format": "YYYY-MM-DD",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "上传建档日期"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                      modelValue: form.createDate,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.createDate = $event),
                      type: "date",
                      placeholder: "",
                      "value-format": "YYYY-MM-DD",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同金额",
                    prop: "contractMoney"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input_number, {
                      modelValue: form.contractMoney,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.contractMoney = $event),
                      modelModifiers: {
                        number: true
                      },
                      min: 0,
                      precision: 2,
                      controls: false,
                      "controls-position": "right",
                      placeholder: "请输入合同金额",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同签订部门",
                    prop: "signDepartment"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.signDepartment,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.signDepartment = $event),
                      placeholder: "请输入合同签订部门",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 11,
                offset: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同责任人",
                    prop: "head"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.head,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.head = $event),
                      placeholder: "请输入合同责任人",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同编号",
                    prop: "contractCode"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.contractCode,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => form.contractCode = $event),
                      placeholder: "请输入合同编号",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "项目名称",
                    prop: "projectName"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.projectName,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => form.projectName = $event),
                      placeholder: "请输入项目名称",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同份数",
                    prop: "contractNum"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.contractNum,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => form.contractNum = $event),
                      type: "number",
                      onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                      placeholder: "请输入合同份数",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "备注",
                    prop: "remark"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.remark,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => form.remark = $event),
                      placeholder: "请输入备注",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "款项支付周期",
                    prop: "payCycle"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: form.payCycle,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => form.payCycle = $event),
                      placeholder: "请输入款项支付周期",
                      disabled: _unref(readOnly)
                    }, null, 8, ["modelValue", "disabled"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "合同附件",
                    prop: "annex"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_upload, {
                      ref_key: "upload",
                      ref: upload,
                      action: _unref(url),
                      accept: ".pdf,.doc,.docx",
                      name: name,
                      headers: headers,
                      "on-success": uploadSuccess,
                      limit: 1,
                      drag: ""
                    }, {
                      tip: _withCtx(() => [_hoisted_13]),
                      default: _withCtx(() => [_createVNode(_component_el_icon, {
                        class: "el-icon--upload"
                      }, {
                        default: _withCtx(() => [_createVNode(_component_upload_filled)]),
                        _: 1
                      }), _hoisted_12]),
                      _: 1
                    }, 8, ["action"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }

};